import { useState } from 'react';
export default function FamilyMembers({
	initalAdultValues = [],
	initalChildValues = [],
	familyMembers,
	setFamilyMembers = () => {}
}) {
	const [childFirstName, setChildFirstName] = useState('');

	function addFamilyMember(type) {
		if (type === 'child') {
			setFamilyMembers((prev) => ({
				children: [...prev.children, initalChildValues],
				adults: prev.adults
			}));
			return;
		} else {
			setFamilyMembers((prev) => ({
				children: prev.children,
				adults: [...prev.adults, initalAdultValues]
			}));
		}
	}

	function removeFamilyMember(index, type) {
		console.log('index', index, type);
		if (type === 'child') {
			setFamilyMembers((prev) => ({
				children: prev.children.filter((child, i) => i !== index),
				adults: prev.adults
			}));
		} else if (type === 'adult') {
			setFamilyMembers((prev) => {
				return {
					adults: prev.adults.filter((adult, i) => i !== index),
					children: prev.children
				};
			});
		}
	}

	function updateFieldInformation(index, attr) {
		setFamilyMembers((prev) => {
			return {
				children: [
					...prev.children.map((child, i) => {
						return i === index
							? {
									...child,
									...attr
								}
							: child;
					})
				],
				adults: [...prev.adults]
			};
		});
	}

	function updateAdultInformation(index, attr) {
		setFamilyMembers((prev) => {
			return {
				adults: [
					...prev.adults.map((adult, i) => {
						return i === index
							? {
									...adult,
									...attr
								}
							: adult;
					})
				],
				children: [...prev.children]
			};
		});
	}

	return (
		<div className="shadow-lg overflow-hidden mt-8 sm:rounded-md" data-sentry-component="FamilyMembers" data-sentry-source-file="index.jsx">
			<div className="px-4 py-5 ">
				<h2 className="border-b-2 mb-4 col-span-6 md:text-2xl font-semibold">
					Family Members in the Home
				</h2>
				{/* Children Section */}
				<h3 className="font-bold text-center">Children</h3>
				{familyMembers.children.map((child, i) => {
					return (
						<div
							key={i}
							className="border border-gray-100 box-border gap-6 grid grid-cols-8 md:mt-4 mt-8 p-3 pl-3 relative rounded-sm shadow-md"
						>
							<div className="col-span-4 sm:col-span-2 ">
								<label
									htmlFor="firstName"
									className="block text-sm font-medium text-gray-700"
								>
									First Name
								</label>
								<input
									onChange={(e) =>
										updateFieldInformation(i, {
											firstName: e.target.value
										})
									}
									onBlur={(e) =>
										setChildFirstName(e.target.value)
									}
									type="text"
									value={child.firstName}
									name="firstName"
									required
									className="mt-1 focus:ring-emerald-300 focus:border-emerald-300 block w-full shadow-xs sm:text-sm border-gray-300 rounded-md"
								/>
							</div>
							<div className="col-span-4 sm:col-span-2  ">
								<label
									htmlFor="ssn"
									className="block text-sm font-medium text-gray-700"
								>
									Last 4 of SSN
								</label>
								<input
									onChange={(e) =>
										updateFieldInformation(i, {
											ssn: e.target.value
										})
									}
									type="text"
									value={child.ssn}
									maxLength="4"
									placeholder="1234"
									pattern="\d\d\d\d"
									name="SSN"
									required
									className="mt-1 focus:ring-emerald-300 focus:border-emerald-300 block w-full shadow-xs sm:text-sm border-gray-300 rounded-md"
								/>
							</div>
							<div className="col-span-4 sm:col-span-2  ">
								<label
									htmlFor="age"
									className="block text-sm font-medium text-gray-700"
								>
									Age
								</label>
								<input
									onChange={(e) =>
										updateFieldInformation(i, {
											age: e.target.value
										})
									}
									type="number"
									maxLength="2"
									name="age"
									className="mt-1 focus:ring-emerald-300 focus:border-emerald-300 block w-full shadow-xs sm:text-sm border-gray-300 rounded-md"
								/>
							</div>
							<div className="col-span-4 sm:col-span-2">
								<label
									htmlFor="gender"
									className="block text-sm font-medium text-gray-700"
								>
									Gender
								</label>
								<select
									onChange={(e) =>
										updateFieldInformation(i, {
											gender: e.target.value
										})
									}
									name="gender"
									className="mt-1 block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-hidden focus:ring-emerald-300 focus:border-emerald-300 sm:text-sm rounded-md"
									defaultValue="Choose"
									required
								>
									<option disabled>Choose</option>
									<option>Male</option>
									<option>Female</option>
									<option>Other</option>
								</select>
							</div>
							<div className="col-span-8 sm:col-span-4 ">
								<label
									htmlFor="toy"
									className="block text-sm font-medium text-gray-700"
								>
									Toy Requests
								</label>
								<input
									onChange={(e) =>
										updateFieldInformation(i, {
											toy: e.target.value
										})
									}
									type="text"
									name="toy"
									value={child.toy}
									className="mt-1 focus:ring-emerald-300 focus:border-emerald-300 block w-full shadow-xs sm:text-sm border-gray-300 rounded-md"
								/>
							</div>
							<div className="col-span-8 sm:col-span-4 ">
								<label
									htmlFor="clothes"
									className="block text-sm font-medium text-gray-700"
								>
									Clothing Requests
								</label>
								<input
									onChange={(e) =>
										updateFieldInformation(i, {
											clothes: e.target.value
										})
									}
									type="text"
									value={child.clothes}
									name="clothes"
									className="mt-1 focus:ring-emerald-300 focus:border-emerald-300 block w-full shadow-xs sm:text-sm border-gray-300 rounded-md"
								/>
							</div>
							<div className="col-span-4 sm:col-span-3 ">
								<label
									htmlFor="shirt"
									className="block text-sm font-medium text-gray-700"
								>
									Shirt Size
								</label>
								<input
									onChange={(e) =>
										updateFieldInformation(i, {
											shirt: e.target.value
										})
									}
									value={child.shirt}
									type="text"
									name="shirt"
									className="mt-1 focus:ring-emerald-300 focus:border-emerald-300 block w-full shadow-xs sm:text-sm border-gray-300 rounded-md"
								/>
							</div>
							<div className="col-span-4 sm:col-span-3 ">
								<label
									htmlFor="pant"
									className="block text-sm font-medium text-gray-700"
								>
									Pant Size
								</label>
								<input
									onChange={(e) =>
										updateFieldInformation(i, {
											pant: e.target.value
										})
									}
									type="text"
									name="pant"
									value={child.pant}
									className="mt-1 focus:ring-emerald-300 focus:border-emerald-300 block w-full shadow-xs sm:text-sm border-gray-300 rounded-md"
								/>
							</div>
							<div className="col-span-4 sm:col-span-2 ">
								<label
									htmlFor="shoe"
									className="block text-sm font-medium text-gray-700"
								>
									Shoe Size
								</label>
								<input
									onChange={(e) =>
										updateFieldInformation(i, {
											shoe: e.target.value
										})
									}
									value={child.shoe}
									type="text"
									name="shoe"
									className="mt-1 focus:ring-emerald-300 focus:border-emerald-300 block w-full shadow-xs sm:text-sm border-gray-300 rounded-md"
								/>
							</div>
							<div className="col-span-8 p-2 flex justify-end">
								{/* Remove Row Button */}
								{familyMembers.children.length > 1 ? (
									<button
										type="button"
										className=" rounded-full border px-2.5 py-1 bg-red-100 text-sm"
										onClick={() =>
											removeFamilyMember(i, 'child')
										}
									>
										X Remove
									</button>
								) : (
									''
								)}
							</div>
						</div>
					);
				})}
				<div className="flex justify-center mt-4">
					<button
						type="button"
						onClick={() => addFamilyMember('child')}
						className="bg-emerald-500 transform hover:scale-105 transition-transform duration-200 rounded-md p-2 mt-2  w-1/3 text-white"
					>
						Add Child
					</button>
				</div>
				{/* Adults Section */}
				<h3 className="font-bold text-center mt-8">
					Additional adults living at this address:
				</h3>
				{familyMembers.adults.map((adult, i) => {
					return (
						<div
							key={i}
							className="border border-gray-100 box-border gap-6 grid grid-cols-8 md:mt-4 mt-8 p-3 pl-3 relative rounded-sm shadow-md"
						>
							<div className="col-span-4 sm:col-span-2 ">
								<label
									htmlFor="firstName"
									className="block text-sm font-medium text-gray-700"
								>
									First Name
								</label>
								<input
									onChange={(e) =>
										updateAdultInformation(i, {
											firstName: e.target.value
										})
									}
									type="text"
									value={adult.firstName}
									name="firstName"
									className="mt-1 focus:ring-emerald-300 focus:border-emerald-300 block w-full shadow-xs sm:text-sm border-gray-300 rounded-md"
								/>
							</div>
							<div className="col-span-4 sm:col-span-2  ">
								<label
									htmlFor="ssn"
									className="block text-sm font-medium text-gray-700"
								>
									Last 4 of SSN
								</label>
								<input
									onChange={(e) =>
										updateAdultInformation(i, {
											ssn: e.target.value
										})
									}
									type="text"
									value={adult.ssn}
									maxLength="4"
									pattern="\d\d\d\d"
									placeholder="1234"
									name="SSN"
									className="mt-1 focus:ring-emerald-300 focus:border-emerald-300 block w-full shadow-xs sm:text-sm border-gray-300 rounded-md"
								/>
							</div>
							<div className="col-span-4 sm:col-span-2  ">
								<label
									htmlFor="age"
									className="block text-sm font-medium text-gray-700"
								>
									Age
								</label>
								<input
									onChange={(e) =>
										updateAdultInformation(i, {
											age: e.target.value
										})
									}
									type="number"
									maxLength="2"
									name="age"
									className="mt-1 focus:ring-emerald-300 focus:border-emerald-300 block w-full shadow-xs sm:text-sm border-gray-300 rounded-md"
								/>
							</div>
							<div className="col-span-4 sm:col-span-2">
								<label
									htmlFor="gender"
									className="block text-sm font-medium text-gray-700"
								>
									Gender
								</label>
								<select
									onChange={(e) =>
										updateAdultInformation(i, {
											gender: e.target.value
										})
									}
									name="gender"
									className="mt-1 block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-hidden focus:ring-emerald-300 focus:border-emerald-300 sm:text-sm rounded-md"
									defaultValue="Choose"
								>
									<option disabled>Choose</option>
									<option>Male</option>
									<option>Female</option>
									<option>Other</option>
								</select>
							</div>
							<div className="col-span-8 p-2 flex justify-end">
								{/* Remove Row Button */}
								{familyMembers.adults.length > 1 ? (
									<button
										type="button"
										className=" rounded-full border px-2.5 py-1 bg-red-100 text-sm"
										onClick={() =>
											removeFamilyMember(i, 'adult')
										}
									>
										X Remove
									</button>
								) : (
									''
								)}
							</div>
						</div>
					);
				})}
				<div className="flex justify-center mt-4">
					<button
						type="button"
						onClick={() => addFamilyMember('adult')}
						className="bg-emerald-500 transform hover:scale-105 transition-transform duration-200 rounded-md p-2 mt-2  w-1/3 text-white"
					>
						Add Adult
					</button>
				</div>
			</div>
		</div>
	);
}
